//@ts-check
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'lodash';
import {messageHandler} from './sinclair/sinclair.uiTools';
import {descendsFrom} from './sinclair/sinclair.utils';
import {ajaxRequest} from './sinclair/sinclair.ajax';

// Applies blacklists to model, returns plain attributes like `toJSON`
//:: Model | Collection -> {}
const toSavableObj = model => {
    const cleanedObj = _.reduce(
        model.attributes || model.models,
        (ob, val, key) => {
            if (!_.includes(model.blacklist, key)) {
                if (_.isArray(val)) {
                    ob[key] = val.map(v => (descendsFrom(Backbone.Model, v) ? toSavableObj(v) : v));
                } else if (descendsFrom(Backbone.Collection, val)) {
                    // recurse Collection
                    ob[key] = val.models.map(toSavableObj);
                } else if (descendsFrom(Backbone.Model, val)) {
                    // recurse Model
                    ob[key] = toSavableObj(val);
                } else {
                    ob[key] = val;
                }
            }
            return ob;
        },
        {},
    );
    return cleanedObj;
};

export const _testExport = {toSavableObj};


// TODO Rather than extending backbone's prototypes we should create
// a base model to extend from or use another technique

// eslint-disable-next-line max-statements
export const enhanceBackbone = () => {
    Backbone.$ = $;

    Backbone.Model.prototype.toJSON = function() {
        const that = this;

        if (that._isSerializing) {
            return this.id || this.cid;
        }

        that._isSerializing = true;

        const json = _.clone(this.attributes);

        _.each(json, function(value, key) {
            if (value instanceof Backbone.Model || value instanceof Backbone.Collection) {
                json[key] = value.toJSON();
            }
        });

        that._isSerializing = false;

        return json;
    };

    const _save = Backbone.Model.prototype.save;

    Backbone.Model.prototype.save = function(attrs = {}, opts = {}) {
        const that = this;
        that.set(attrs);
        const _attrs = toSavableObj(that);
        opts.contentType = opts.contentType || 'application/json';
        opts.attrs = that.legacyRestShim
            ? {
                data: _attrs,
            }
            : _attrs;
        return _save.call(that, null, opts);
    };

    const proxiedSync = Backbone.sync;
    Backbone.sync = function(method, model, options = {}) {
        if (!options.xhrFields) {
            options.xhrFields = {
                withCredentials: true,
            };
        }

        return proxiedSync(method, model, options);
    };

    Backbone.ajax = ajaxRequest;
};

export const enhanceBackboneWithUserModel = (_userModel) => {
    let userModel = _userModel;

    Backbone.View.prototype.hasAnyPermission = function(permissionSet) {
        return userModel.userHasAnyPermissionSet(permissionSet);
    };
    Backbone.View.prototype.hasPermission = function(permissionSet, propertyUuid) {
        return userModel.userHasPermissionSet(permissionSet, propertyUuid || null);
    };
    Backbone.View.prototype.permissionGranted = function(permissionSet, propertyUuid) {
        return userModel.userHasPermissionSet(permissionSet, propertyUuid || null);
    };
    Backbone.View.prototype.permissionDenied = function(
        permissionSet,
        propertyUuid = null,
        errorRoute = 'home',
        errorMessage = 'You do not have permission to view that page',
    ) {
        if (!userModel.userHasPermissionSet(permissionSet, propertyUuid)) {
            this.routeChanger(errorRoute, 'error', errorMessage);

            return true;
        }

        return false;
    };

    [Backbone.Model.prototype, Backbone.View.prototype, Backbone.Collection.prototype].forEach(function(prototype) {
        Object.defineProperty(prototype, 'debugModel', {
            get() {
                return userModel.debugModel;
            },
            set(debugModel) {
                userModel.debugModel = debugModel;
            },
        });

        Object.defineProperty(prototype, 'userModel', {
            get() {
                return userModel;
            },
            set(newUserModel) {
                userModel = newUserModel;
            },
        });
    });
};

export const enhanceBackboneWithRouter = router => {
    Backbone.View.prototype.hideNavPanel = () => router._hideNavPanel();
    Backbone.View.prototype.showNavPanel = () => router._showNavPanel();
    Backbone.View.prototype.routeChanger = (path, type, primaryMessage, secondaryMessage = '') => {
        router.navigate(path, true);

        if (primaryMessage && type) {
            messageHandler(type, primaryMessage, secondaryMessage);
        }
    };
    Backbone.View.prototype.routeChangerData = (path, type, primaryMessage, secondaryMessage = '', opts) => {
        router.navigate(path, true);

        if (primaryMessage && type) {
            messageHandler(type, primaryMessage, secondaryMessage);
        }
        router._controller(opts);
    };
};
